import { buildProps } from '@sgui-plus/utils/props'
import { createModelToggleComposable } from '@sgui-plus/hooks'
import { usePopperArrowProps } from '@sgui-plus/components/popper'
import { useTooltipContentProps } from './content'
import { useTooltipTriggerProps } from './trigger'
import type Tooltip from './tooltip.vue'

import type { ExtractPropTypes } from 'vue'

export const {
  useModelToggleProps: useTooltipModelToggleProps,
  useModelToggleEmits: useTooltipModelToggleEmits,
  useModelToggle: useTooltipModelToggle
} = createModelToggleComposable('visible' as const)

export const useTooltipProps = buildProps({
  ...useTooltipModelToggleProps,
  ...useTooltipContentProps,
  ...useTooltipTriggerProps,
  ...usePopperArrowProps,
  openDelay: {
    type: Number,
  },
  visibleArrow: {
    type: Boolean,
    default: undefined,
  },
  hideAfter: {
    type: Number,
    default: 200,
  },
  showArrow: {
    type: Boolean,
    default: true,
  },
  hideDelay: {
    type: Number,
    default: 3000
  },
  // 气泡内容是以 v-if 的方式显示，还是 v-show 的方式显示，默认 v-if
  renderContentType: {
    type: String,
    values: ['if', 'show'],
    default: 'if'
  }
})

export const useTooltipEmits = [
  ...useTooltipModelToggleEmits,
  'before-show',
  'before-hide',
  'show',
  'hide',
  'open',
  'close',
]

export type SgTooltipProps = ExtractPropTypes<typeof useTooltipProps>

export type TooltipInstance = InstanceType<typeof Tooltip>
